module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade-in",
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostrarModal),
      expression: "mostrarModal"
    }],
    staticClass: "modal fade-in",
    staticStyle: {
      "z-index": "99999"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "close",
    staticStyle: {
      "position": "absolute",
      "top": "10px",
      "right": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('h2', [_vm._v("Mudança para padrão Mercosul")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "information-container"
  }, [_c('p', {
    staticClass: "infoModal"
  }, [_vm._v("\n            Não foi possível realizar a mudança do padrão da placa no momento!\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("Fechar")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-0d5dec99!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal-error-merc.vue
// module id = 2045
// module chunks = 1